import React, { useEffect, useMemo, useState } from 'react';

// Styles & Assets
import styles from './TablePatients.module.css';

// Services
import { setColor } from '../../../services/Patient';
import { getEnvironmentApiUrl } from '../../../services/General';

// Hooks
import { useContext } from 'react';
import useFilteredPatients from '../../../hooks/useFilteredPatients';
import useHttp from '../../../hooks/useHttp';

// Context
import ColumnsContext from '../../../context/ColumnsContext';
import GeneralContext from '../../../context/GeneralContext';
import { PatientChatsMap } from '../../../context/ChatContext';

// Components 
import Table from '../../UI/Table/Table';

// Interfaces
import { Patient } from '../../../interfaces/Patient';
import { usePatientChats } from '../../../hooks/usePatientChats';

// TablePatients: handles of the logic to request the patients data, filters it and 
// the columns and then calls the Ta8ble component. Props:
//  -handlePatientClick: function that gets passed the id of the patient click.
const TablePatients: React.FC<{
    handlePatientClick: (id: number) => void,
    setColorRow?: (patient: Patient) => string | undefined,
    filterColumnsIDs?: number[],
    activePatientID?: number | null
}> = ({ handlePatientClick, setColorRow, filterColumnsIDs, activePatientID }) => {

    const columnsContext = useContext(ColumnsContext);
    const generalContext = useContext(GeneralContext);

    const { filteredPatients } = useFilteredPatients();
    const filteredColumns = filterColumnsIDs ?
        columnsContext.columnsPatients.filter(col => col.id === undefined || !filterColumnsIDs.includes(col.id))
        :
        columnsContext.columnsPatients;

    const patientIds = useMemo(() => filteredPatients.map(p => p.id),[filteredPatients]);

    const patientChats = usePatientChats(patientIds);

    const patientsWithChat = useMemo(() => {
        return filteredPatients.map(patient => ({
            ...patient,
            chatInfo: patientChats[patient.id] ?? null
        }));
    }, [filteredPatients, patientChats]);
    
    return (
        <div className={styles.patientTableContainer}>
            <Table
                columns={filteredColumns}
                rows={patientsWithChat}
                defaultColumnToOrder={[
                    generalContext.patientsTableColumnOrder,
                    generalContext.setPatientsTableColumnOrder
                ]}
                setColorRow={setColorRow ? setColorRow : setColor}
                onClickRow={handlePatientClick}
                activeRowID={activePatientID}
            />
        </div>
    );
};
export default TablePatients;